import React from 'react'

import SEO from '../../components/shared/SEO'
import CasestudyArchiveTemplate from '../../components/templates/CasestudyTemplate/CasestudyArchive'
import { getNotePosts } from '../../utils/Note'

type Props = {
  notePosts: any
}

const CasestudyPage: React.FC<Props> = ({ notePosts }) => (
  <>
    <SEO
      title="導入事例 | RYDE株式会社"
      description="RYDE PASS（ライドパス）の導入事例をご紹介するページです。"
      openGraph={{
        images: [
          {
            url: 'https://ryde-inc.jp/og_image.png',
          },
        ],
        type: 'website',
        url: 'https://ryde-inc.jp/',
        site_name:
          'RYDE株式会社 | 二次交通をわかりやすく、使いやすく、そして持続可能に',
        locale: 'ja_JP',
      }}
    />
    <CasestudyArchiveTemplate notePosts={notePosts} />
  </>
)

export async function getStaticProps() {
  const data = await Promise.all([getNotePosts()])

  return {
    props: {
      notePosts: data[0].data,
    } as Props,
    revalidate: 60,
  }
}

export default CasestudyPage
